// views/Dashboard/Overview/components/FreeTierNotice/FreeTierNotice.tsx
import { useNavigate } from 'react-router-dom';
import styles from './FreeTierNotice.module.css';

interface FreeTierNoticeProps {
  totalDays?: number;
  tier: { creation_timestamp?: number };
}

const countDaysLeft = (startTimestamp: number | undefined, totalDays: number): number => {
  const start = new Date((startTimestamp ?? 0) * 1000).getTime();
  const end = start + totalDays * 24 * 60 * 60 * 1000;
  const diffMs = end - Date.now();
  return diffMs <= 0 ? 0 : Math.floor(diffMs / (24 * 60 * 60 * 1000));
};

const FreeTierNotice = ({ totalDays = 60, tier }: FreeTierNoticeProps) => {
  const navigate = useNavigate();

  const daysLeft = countDaysLeft(tier.creation_timestamp, totalDays);
  const elapsed = totalDays - daysLeft;
  const pct = Math.round((elapsed / totalDays) * 100);

  return (
    <div className={styles.notice}>
      <div className={styles.header}>
        <span className={styles.headerIcon}>⚠️</span>
        <div>
          <h2 className={styles.headerTitle}>Tarif Free není podporován</h2>
          <p className={styles.headerSub}>Váš účet bude zrušen, pokud neupgradujete</p>
        </div>
      </div>

      <p className={styles.description}>
        Aktuálně nepodporujeme <strong>Free</strong> tarify. Upgradujte na jiný tarif do{' '}
        <strong>{daysLeft}&nbsp;dní</strong>, abyste zabránili zrušení účtu a&nbsp;ztrátě dat.
      </p>

      <div className={styles.countdown}>
        <div className={styles.badge}>
          <span className={styles.badgeNum}>{daysLeft}</span>
          <span className={styles.badgeLabel}>dní zbývá</span>
        </div>
        <div className={styles.progressWrap}>
          <div className={styles.progressBg}>
            <div className={styles.progressFill} style={{ width: `${pct}%` }} />
          </div>
          <div className={styles.progressLabels}>
            <span>dnes</span>
            <span>{totalDays} dní</span>
          </div>
        </div>
      </div>

      <div className={styles.consequences}>
        <p className={styles.consequencesTitle}>Co se stane po uplynutí lhůty</p>
        <ul className={styles.list}>
          <li>Přístup ke všem funkcím bude zablokován</li>
          <li>Váš účet a data budou trvale odstraněny</li>
          <li>Nevyplacené výdělky z bonusů a doporučení propadnou</li>
        </ul>
      </div>

      <button className={styles.upgradeBtn} onClick={() => navigate('settings?activeTab=membership')}>
        Upgradovat tarif →
      </button>
    </div>
  );
};

export default FreeTierNotice;
